module.exports = __webpack_public_path__ + "static/media/uncheck.7f8b4620.svg";